import { Alert } from "@mui/material";
import { useMemo } from "react";
import { FormDataConsumer, SimpleForm } from "react-admin";
import CustomToolbar from "./components/CustomToolbar";
import FormHeader from "./components/FormHeader";
import JboxInputsTables from "./components/JboxInputsTables";
import { getDefaultFormValues } from "./constants/defaultValues";
import useTestsAfrrRteForm from "./hooks/useTestsAfrrRteForm";
import { makeValidateForm } from "./validations";

export default function TestsAfrrRteForm() {
  const { handleSubmit, errors, iecConfigInfo, planningsPosted } = useTestsAfrrRteForm();

  const defaultValues = useMemo(() => getDefaultFormValues(), []);

  // Compute whether IEC list is truly available
  const iecAvailable = useMemo(() => {
    const { iecConfigChoices, iecConfigsLoading, iecConfigsError } = iecConfigInfo;
    return !iecConfigsLoading && !iecConfigsError && (iecConfigChoices?.length ?? 0) > 0;
  }, [iecConfigInfo]);

  // Bind validator to current IEC availability
  const validate = useMemo(() => makeValidateForm(iecAvailable), [iecAvailable]);

  return (
    <SimpleForm
      validate={validate}
      onSubmit={handleSubmit}
      toolbar={<CustomToolbar />}
      defaultValues={() => defaultValues}
    >
      <FormHeader />

      <FormDataConsumer>
        {({ formData }) => <JboxInputsTables formData={formData} iecConfigInfo={iecConfigInfo} />}
      </FormDataConsumer>

      {planningsPosted && (
        <Alert severity="success" sx={{ width: "100%", mb: 2 }}>
          <strong>Plannings posted successfully</strong>
        </Alert>
      )}

      {errors.length > 0 &&
        errors.map((error, index) => (
          <Alert key={index} severity="error" sx={{ width: "100%" }}>
            <strong>{error}</strong>
          </Alert>
        ))}
    </SimpleForm>
  );
}
